import React from "react";
import { Wrap, StyledWrapProps } from "./styles";

/* 타입 */
interface PaginationItemProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    StyledWrapProps {
  disabled?: boolean;
}

/* 컴포넌트 */
const PaginationItem = ({
  unclickable,
  selected,
  children,
  ...rest
}: PaginationItemProps) => {
  return (
    <Wrap unclickable={unclickable} selected={selected} {...rest} type="button">
      {children}
    </Wrap>
  );
};

export default PaginationItem;
